import { SyntheticEvent } from "react";
import colors from "../config/colors";

// The same neutral mark the API boundary serves for a service with no stored
// logo, bundled so the catalogue still has something to draw when the network
// does not answer. Square by design: a mark of a different shape reflows the
// grid as the logo job fills entries in.
const NEUTRAL_SERVICE_MARK = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="64" height="64" role="img" aria-label="Service"><rect x="6.5" y="6.5" width="51" height="51" rx="10" fill="none" stroke="${colors.serviceMarkColor}" stroke-width="2.5"/><path d="M18 27h28M18 27l3.5-7h21L46 27M22 27v14h20V27M28 41v-8h8v8" fill="none" stroke="${colors.serviceMarkColor}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

// Inlined rather than fetched: a placeholder that needs the network is not a
// placeholder for a network that is down.
export const DEFAULT_SERVICE_LOGO = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
  NEUTRAL_SERVICE_MARK
)}`;

// One definition, because every site that renders a supplier logo needs the
// identical swap and the re-entry guard: a handler that reassigns src without
// checking loops forever when the replacement itself fails to load.
export const swapToDefaultServiceLogo = (
  event: SyntheticEvent<HTMLImageElement>
) => {
  const image = event.currentTarget;
  if (image.src !== DEFAULT_SERVICE_LOGO) {
    image.src = DEFAULT_SERVICE_LOGO;
  }
};
